import type { PlaceIcon } from 'features/places/places.types';
import type { MapIcon } from 'features/mapping/mapping.types';

export const PlaceLocationPinIcon: MapIcon = {
  name: 'PlaceLocationPin',
  width: 21,
  height: 30,
  offset: [0, -14],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCAyOSA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjA2NDEgMzIuNzI3OEM5LjEwMTIxIDMxLjE4MzMgNy45OTY3NyAyOS43NTA4IDYuOTEwNzggMjguMzQyM0w2Ljg2ODQ4IDI4LjI4NzRDNS43NjM2NyAyNi44NTQ0IDQuNjc5NyAyNS40NDQ1IDMuNzQ1NTQgMjMuOTMwMkwzLjc0NTEzIDIzLjkyOTVDMS45NzA0IDIxLjA2MjYgMSAxNy44OTMgMSAxNC41MTI3QzEgNy4wNDg4NCA3LjAzNjE0IDEuMDEyNyAxNC41IDEuMDEyN0MyMS45NjM5IDEuMDEyNyAyOCA3LjA0ODg0IDI4IDE0LjUxMjdDMjggMTcuODkyOCAyNy4wMjk3IDIxLjA2MTcgMjUuMjM2MSAyMy45Mjc0TDI1LjIzMzcgMjMuOTMxNEMyNC4yOTk3IDI1LjQ1NTIgMjMuMjE1OSAyNi44NyAyMi4xMTE1IDI4LjMwMjRMMjIuMDE1NSAyOC40MjY5QzIwLjk0NzIgMjkuODEyMyAxOS44NjMzIDMxLjIxOCAxOC45MTY1IDMyLjcyNjlMMTguOTE2MyAzMi43MjcyQzE3Ljk1NzUgMzQuMjU3MiAxNy4yODYgMzUuNjgzMiAxNi41NDUyIDM3LjMwNDlMMTYuNTQ0OCAzNy4zMDU4QzE2LjQ1MzYgMzcuNTA2NSAxNi4zNjIxIDM3LjczOTIgMTYuMjcyMyAzNy45Njc2QzE2LjIzMzUgMzguMDY2MyAxNi4xOTUgMzguMTY0MiAxNi4xNTcgMzguMjU4M0MxNi4wMjQ5IDM4LjU4NTQgMTUuODg3NyAzOC44OTcgMTUuNzI1NSAzOS4xNjkyQzE1LjQwMzEgMzkuNzEwMiAxNS4wMzc0IDQwLjAxMjcgMTQuNSA0MC4wMTI3QzEzLjk2MjUgNDAuMDEyNyAxMy41OTY2IDM5LjcxMDIgMTMuMjcxMiAzOS4xNjc5QzEzLjEwNzYgMzguODk1MSAxMi45Njg0IDM4LjU4MyAxMi44MzMyIDM4LjI1NUMxMi43OTg0IDM4LjE3MDUgMTIuNzYzMiAzOC4wODMyIDEyLjcyNzYgMzcuOTk1MkMxMi42MzIgMzcuNzU4MSAxMi41MzM5IDM3LjUxNTIgMTIuNDM0NiAzNy4zMDQzQzExLjcxMTIgMzUuNjc3MSAxMS4wMjA4IDM0LjI1NDUgMTAuMDY0MSAzMi43Mjc4Wk0xMC4wNjQxIDMyLjcyNzhDMTAuMDYzOSAzMi43Mjc2IDEwLjA2MzggMzIuNzI3NCAxMC4wNjM3IDMyLjcyNzJMOS42NCAzMi45OTI3TDEwLjA2NDMgMzIuNzI4MkMxMC4wNjQyIDMyLjcyODEgMTAuMDY0MiAzMi43Mjc5IDEwLjA2NDEgMzIuNzI3OFoiIGZpbGw9IiM2MzkzRjIiIHN0cm9rZT0iIzQ2NjVBMiIvPgo8L3N2Zz4K',
};

export const HomePlaceIcon: MapIcon = {
  name: 'HomePlace',
  width: 14,
  height: 12,
  offset: [0, -18],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyMCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTdWMTFIMTJWMTdIMTdWOUgyMEwxMCAwTDAgOUgzVjE3SDhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K',
};

export const StorePlaceIcon: MapIcon = {
  name: 'StorePlace',
  width: 12,
  height: 10,
  offset: [0, -18],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3IDBIMVYySDE3VjBaTTE4IDEwVjhMMTcgM0gxTDAgOFYxMEgxVjE2SDExVjEwSDE1VjE2SDE3VjEwSDE4Wk05IDE0SDNWMTBIOVYxNFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=',
};

export const ApartmentPlaceIcon: MapIcon = {
  name: 'ApartmentPlace',
  width: 12,
  height: 12,
  offset: [0, -18],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDhWMEg0VjRIMFYxOEg4VjE0SDEwVjE4SDE4VjhIMTRaTTQgMTZIMlYxNEg0VjE2Wk00IDEySDJWMTBINFYxMlpNNCA4SDJWNkg0VjhaTTggMTJINlYxMEg4VjEyWk04IDhINlY2SDhWOFpNOCA0SDZWMkg4VjRaTTEyIDEySDEwVjEwSDEyVjEyWk0xMiA4SDEwVjZIMTJWOFpNMTIgNEgxMFYySDEyVjRaTTE2IDE2SDE0VjE0SDE2VjE2Wk0xNiAxMkgxNFYxMEgxNlYxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=',
};

export const WorkPlaceIcon: MapIcon = {
  name: 'WorkPlace',
  width: 12,
  height: 12,
  offset: [0, -18],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDRIMTRWMkMxNCAwLjg5IDEzLjExIDAgMTIgMEg4QzYuODkgMCA2IDAuODkgNiAyVjRIMkMwLjg5IDQgMC4wMDk5OTk5OSA0Ljg5IDAuMDA5OTk5OTkgNkwwIDE3QzAgMTguMTEgMC44OSAxOSAyIDE5SDE4QzE5LjExIDE5IDIwIDE4LjExIDIwIDE3VjZDMjAgNC44OSAxOS4xMSA0IDE4IDRaTTEyIDRIOFYySDEyVjRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K',
};

export const SchoolPlaceIcon: MapIcon = {
  name: 'SchoolPlace',
  width: 14,
  height: 12,
  offset: [0, -18],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMTAuMThWMTQuMThMMTEgMThMMTggMTQuMThWMTAuMThMMTEgMTRMNCAxMC4xOFpNMTEgMEwwIDZMMTEgMTJMMjAgNy4wOVYxNEgyMlY2TDExIDBaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K',
};

export const BarnPlaceIcon: MapIcon = {
  name: 'BarnPlace',
  width: 14,
  height: 12,
  offset: [0, -18],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljk5MTIzIDE1Ljg1OTFMNy43NjMzMSAxOEgxMi4yMzY0TDkuOTkxMjMgMTUuODU5MVpNOC41NTE3NiA3Ljc3MzA2SDExLjQ0ODFWNS44OTU2Mkg4LjU1MTc2VjcuNzczMDZaTTE0IDEyVjE4SDE4LjA5NzdWOC45OTE3OEMxOC4wOTc3IDguNzQ0NzkgMTguMzAzMyA4LjU2MzYyIDE4LjU0MzIgOC41NjM2MkgyMEwxNi4wNTgyIDMuMTk0OThMOS45OTEzOSAwTDMuOTI0NTggMy4xOTQ5OEwwIDguNTYzNjJIMS40Mzk2M0MxLjY5NjY2IDguNTYzNjIgMS44ODUyIDguNzQ0NzkgMS44ODUyIDguOTkxNzhWMThINi4wNTQ0M1YxMkM2LjA1NDQzIDExLjc2OTUgNi4yNDI5NyAxMS41NzE4IDYuNSAxMS41NzE4SDEzLjU1NDZDMTMuNzk0NSAxMS41NzE4IDE0IDExLjc2OTUgMTQgMTJaTTExLjg3NjUgOC42MTI4OUg4LjEwNjE3QzcuODY2MjYgOC42MTI4OSA3LjY2MDYgOC40MzE3MiA3LjY2MDYgOC4xODQ3M1Y1LjQ2NzQ0QzcuNjYwNiA1LjIzNjkxIDcuODY2MjYgNS4wMzkyOCA4LjEwNjE3IDUuMDM5MjhIMTEuODc2NUMxMi4xMzM1IDUuMDM5MjggMTIuMzIyMSA1LjIzNjkgMTIuMzIyMSA1LjQ2NzQ0VjguMTg0NzNDMTIuMzIyMSA4LjQzMTcxIDEyLjEzMzYgOC42MTI4OSAxMS44NzY1IDguNjEyODlaTTkuMzc0NDMgMTUuMjQ5Nkw3LjEyOTM4IDEzLjEwODhWMTcuNDA3MUw5LjM3NDQzIDE1LjI0OTZaTTEyLjg1MzUgMTMuMTA4OEwxMC42MjU2IDE1LjI0OTZMMTIuODUzNSAxNy40MDdWMTMuMTA4OFpNOS45OTE1OCAxNC42NTY4TDEyLjIzNjYgMTIuNTE1OUg3Ljc2MzUxTDkuOTkxNTggMTQuNjU2OFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=',
};

export const StarPlaceIcon: MapIcon = {
  name: 'StarPlace',
  width: 14,
  height: 12,
  offset: [0, -18],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjE0NCA1LjgwODAxTDE5IDYuNjAwMDVDMTkuMjY0IDYuNjI0MDMgMTkuMzg0IDYuOTYwMDUgMTkuMTkyIDcuMTUyMDlMMTQuOTkyIDExLjMyODFDMTQuOTIgMTEuNDAwMSAxNC44NzIgMTEuNTIwMSAxNC44OTYgMTEuNjE2TDE1Ljk3NiAxNy40MjRDMTYuMDI0IDE3LjY4OCAxNS43MzYgMTcuOTA0IDE1LjQ5NiAxNy43ODRMMTAuMjQgMTUuMDcyMkMxMC4xNDQgMTUuMDI0MyAxMC4wMjQgMTUuMDI0MyA5LjkyNzk2IDE1LjA3MjJMNC43NDM5NiAxNy45MDQyQzQuNTAzOTYgMTguMDI0MiA0LjIxNiAxNy44MzIyIDQuMjYzOTYgMTcuNTY4Mkw1LjE5OTk4IDExLjczNjJDNS4yMjM5NiAxMS42NDAyIDUuMTc1OTkgMTEuNTIwMiA1LjEwMzk2IDExLjQ0ODNMMC44MzE5NjEgNy4zNjgyN0MwLjYzOTkyOSA3LjE3NjI0IDAuNzM1OTQ1IDYuODQwMzEgMC45OTk5MjkgNi44MTYyM0w2LjgzMjEzIDUuODgwMjFDNi45MjgxNSA1Ljg1NjIyIDcuMDI0MTYgNS43ODQxOSA3LjA3MjEzIDUuNjg4MTdMOS42MTYxMyAwLjM2MDE3NkM5LjczNjEzIDAuMTIwMTc2IDEwLjA3MjEgMC4xMjAxNzYgMTAuMTkyMSAwLjM2MDE3NkwxMi45MDQxIDUuNjQwMThDMTIuOTUyMiA1LjczNjE5IDEzLjAyNDEgNS44MDgxNCAxMy4xNDQxIDUuODA4MTRMMTMuMTQ0IDUuODA4MDFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K',
};

export const TrianglePlaceIcon: MapIcon = {
  name: 'TrianglePlace',
  width: 14,
  height: 12,
  offset: [0, -18],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNSAwTDE4LjU5MzMgMTUuNzVIMC40MDY3MzRMOS41IDBaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K',
};

export const SquarePlaceIcon: MapIcon = {
  name: 'SquarePlace',
  width: 12,
  height: 12,
  offset: [0, -18],
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==',
};

export const placeTypeIcons: Record<PlaceIcon, MapIcon> = {
  home: HomePlaceIcon,
  store: StorePlaceIcon,
  apartment: ApartmentPlaceIcon,
  work: WorkPlaceIcon,
  school: SchoolPlaceIcon,
  barn: BarnPlaceIcon,
  star: StarPlaceIcon,
  triangle: TrianglePlaceIcon,
  square: SquarePlaceIcon,
};

export const getPlaceIcon = (icon: PlaceIcon): MapIcon => {
  return placeTypeIcons[icon] || placeTypeIcons.square;
};

/** Icons to register as map images. */
export const placeIcons: MapIcon[] = [
  PlaceLocationPinIcon,
  HomePlaceIcon,
  StorePlaceIcon,
  ApartmentPlaceIcon,
  WorkPlaceIcon,
  SchoolPlaceIcon,
  BarnPlaceIcon,
  StarPlaceIcon,
  TrianglePlaceIcon,
  SquarePlaceIcon,
];
